import type { ShallowRef } from 'vue'

export function scrollIntoView(
  refAnchor: ShallowRef<HTMLElement | null>,
  options: ScrollIntoViewOptions = {
    behavior: 'smooth',
    // Same as alignToTop
    block: 'start',
    inline: 'nearest',
  },
) {
  // We are forced to use a timeout here to avoid any priority conflict between
  // click events and v-model which caused the scroll not to happen
  // Note: nextTick() doesnt help
  setTimeout(() => refAnchor.value?.scrollIntoView(options), 0)
}
